var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderSearchLots',{attrs:{"img_header":_vm.header_image,"header":"รายละเอียดล็อตสินค้า"}}),_c('Search_ProductLots_Detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }